import { FormControl, VStack, WarningIcon } from 'native-base';
import { Caption, H2 } from '~/shared/Typography';
import React from 'react';
import { Button } from '~/shared/Theme';

type CancelSubscriptionProps = {
    onCancel: () => void;
    onProceed: () => void;
    isLoading: boolean;
    error?: string[] | string;
};

const CancelSubscription = ({
    onCancel,
    onProceed,
    isLoading,
    error
}: CancelSubscriptionProps) => {

    return (
        <FormControl>
            <VStack textAlign={'center'} space={4}>
                <H2 text={'subscriptions.cancellation_warning'} />
                <Caption text={'subscriptions.cancellation_disclaimer'} />
                <FormControl.ErrorMessage
                    leftIcon={<WarningIcon size={3} />}
                >
                    { error && error[0] }
                </FormControl.ErrorMessage>
                <Button
                    variant={'danger'}
                    text={'subscriptions.manage.cancel_subscription'}
                    onPress={onProceed}
                />
                <Button
                    variant={'neutral'}
                    loading={isLoading}
                    onPress={onCancel}
                    text={'subscriptions.back_button'}
                />
            </VStack>
        </FormControl>
    );
};

export default CancelSubscription;
